import { createStore } from 'vuex'
const URL = 'https://server-web.konaweselatankab.go.id/';
const URL_SIMPEG = 'https://server-egov.konaweselatankab.go.id/';

export default createStore({
  state: {
    URL_APP: URL,
    URL_APP_SIMPEG: URL_SIMPEG,
    URL_SLIDER: URL + "api/v1/publish_dkp_slider/",
    URL_SAMBUTAN: URL + "api/v1/publish_dkp_sambutan/",
    ADD_URL_BERITA: URL + "api/v1/web_publish_berita/",


    ADD_URL_PROFIL: URL + "api/v1/publish_dkp_tujuan_sasaran/",
    ADD_URL_TUGAS: URL + "api/v1/publish_dkp_tugas_pokok/",
    ADD_URL_STRUKTUR: URL + "api/v1/publish_dkp_struktur_organisasi/",
    ADD_URL_PEGAWAI: URL + "api/v1/publish_dkp_profilstruktural/",
    ADD_URL_KEBIJAKAN: URL + "api/v1/publish_dkp_kebijakan/",



    ADD_URL_UNIT_KERJA: URL + "api/v1/publish_dkp_unit_kerja/",


    LAYANAN_KELAYAKAN: URL + "api/v1/publish_dkp_kelayakan_pengelolahan/",
    LAYANAN_SBI: URL + "api/v1/publish_dkp_sertifikasi_budidaya_ikan/",
    LAYANAN_SPI: URL + "api/v1/publish_dkp_sertifikasi_pembenihan_ikan/",
    LAYANAN_IZIN_ANGKUT: URL + "api/v1/publish_dkp_surat_izin_kapal_pengangkutan_ikan/",
    LAYANAN_IZIN_TANGKAP: URL + "api/v1/publish_dkp_surat_izin_penangkapan_ikan/",
    LAYANAN_IZIN_USAHA: URL + "api/v1/publish_dkp_surat_izin_usaha_perikanan/",

    LAYANAN_KP: URL + "api/v1/publish_dkp_peraturan/",
    LAYANAN_UPTD: URL + "api/v1/publish_dkp_uptd/",



    URL_DOKUMEN: URL + "api/v1/publish_dkp_peraturan/",
    URL_DATA: URL + "api/v1/publish_dkp_uptd/",




    ADD_FOTO: URL + "api/v1/publish_dkp_foto/",
    ADD_VIDEO: URL + "api/v1/publish_dkp_video/",
    FILE_LOAD : URL + "uploads/",
    UNIT_KERJA: 'rAGBTesuJmkFJyLRd',
    TAHUN: '2019'
  }
})